/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from '@americanexpress/dls-react';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormDateRangeSelectItem = React.memo(({ formField, pageData, setPageData }) => {
  const {
    id, value,
  } = formField;
  const [rangeDateStatus, setRangeDateStatus] = useState('default');
  const [dates, setDates] = React.useState({
    start: value?.split('-')[0] || '',
    end: value?.split('-')[1] || '',
  });
  const ids = {
    start: `${id}-drpicker-start`,
    end: `${id}-drpicker-end`,
  };

  useEffect(() => {
    if (value === '') {
      setDates({
        start: '',
        end: '',
      });
    }
  }, [pageData]);

  const handleOnChange = (e) => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[id].value = e;
    setPageData(updatedPageData);
  };

  useEffect(() => {
    if (dates.start && dates.end) {
      const start = new Date(dates.start);
      const end = new Date(dates.end);
      if (start.valueOf() <= end.valueOf()) {
        setRangeDateStatus('default');
        handleOnChange(`${dates.start}-${dates.end}`);
      } else {
        setRangeDateStatus('error');
      }
    }
  }, [dates]);

  const onDateChange = (event, date) => {
    // eslint-disable-next-line no-unused-expressions
    event.target.name === ids.start ? setDates((oldState) => ({
      ...oldState,
      start: date.invalid ? '' : date.dateString,
      end: '',
    })) : setDates((oldState) => ({
      ...oldState,
      end: date.invalid ? '' : date.dateString,
    }));
  };
  return (
    <div>

      <DateRangePicker
        dates={dates}
        ids={ids}
        labels={{
          end: 'End Date',
          endCalendarButton: `${id}-drpicker-end-button`,
          nextMonth: `${id}-drpicker-nextMonth`,
          previousMonth: `${id}-drpicker-prevMonth`,
          start: 'Start Date',
          startCalendarButton: `${id}-drpicker-start-button`,
        }}
        status={rangeDateStatus}
        onChange={onDateChange}
        css={advFormStyles['.daterangePicker']}
      />

    </div>
  );
});

export default AdvFormDateRangeSelectItem;
